/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ErrorType = {
    Unknown: 'Unknown',
    DeviceUnicheck: 'Device_Unicheck',
    DeviceOctavius: 'Device_Octavius'
} as const;
export type ErrorType = typeof ErrorType[keyof typeof ErrorType];


export function ErrorTypeFromJSON(json: any): ErrorType {
    return ErrorTypeFromJSONTyped(json, false);
}

export function ErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorType {
    return json as ErrorType;
}

export function ErrorTypeToJSON(value?: ErrorType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ErrorType interface.
 */
 export function instanceOfErrorType(value: any): value is ErrorType {
    return Object.values(ErrorType).includes(value)
}

